//var vueMiniCalendar = require('./vueMiniCalendar')
//module.exports = vueMiniCalendar

import vueMiniCalendar from './vueMiniCalendar';

export default vueMiniCalendar


// WEBPACK FOOTER //
// ./src/index.js